import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="entrypoints" id="entrypoints"></a>
    <h1 {...{
      "id": "requireuxpentrypoints"
    }}>{`require('uxp').entrypoints`}</h1>
    <p>{`To get an instance: `}<inlineCode parentName="p">{`require("uxp").entrypoints`}</inlineCode></p>
    <a name="entrypoints-setup" id="entrypoints-setup"></a>
    <h2 {...{
      "id": "setupentrypoints"
    }}>{`setup(entrypoints)`}</h2>
    <p>{`API for plugin to add handlers and menu items for entrypoints defined in manifest.
This API can only be called once and there after other apis can be used to modify menu items.
The function throws in case of any error in entrypoints data or if its called more than once.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`entrypoints`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`it consists of mainly three objects - 'plugin', 'panels' and 'commands'.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`entrypoints.plugin`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This can be an object or a function. If this is a function, it is                                           assumed as the 'create' handler (described below).`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`entrypoints.plugin.create`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This is called after plugin is loaded. 'this' can be used to access                                         UxpPluginInfo object. If 'plugin' object is defined, 'create' must be defined.                                         To signal failure, throw an exception.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`entrypoints.plugin.destroy`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This is called before plugin is unloaded. 'this' can be used to access                                          UxpPluginInfo object.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`entrypoints.panels`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array<object>`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This contains a list of key-value pairs where each key is a panel id (string) and                               value is the data for the panel whose type can be object/function.                               If a function, it is assumed to be the 'show' method (described below).                               If an object, it can contain following properties but it is must to                               define either of 'create' or 'show'.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`entrypoints.panels.create`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This is called when a panel is created. 'this' can be used to access                                         UxpPanelInfo object. This function can return a promise.                                         To signal failure, throw an exception or return a rejected promise.                                         This has a default Timeout of 300 MSec from manifest v5 onwards.                              Parameters :                                          create(event) {}, till Manifest Version V4                                          create(rootNode) {}, from v5 onwards`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`entrypoints.panels.show`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This is called when a panel is shown. 'this' can be used to access                                         UxpPanelInfo object. This function can return a promise.                                         To signal failure, throw an exception or return a rejected promise.                                         This has a default Timeout of 300 MSec from manifest v5 onwards.                              Parameters :                                          show(event) {}, till Manifest Version V4                                          show(rootNode, data) {}, from v5 onwards`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`entrypoints.panels.hide`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This is called when a panel is hidden. 'this' can be used to access                                       UxpPanelInfo object. This function can return a promise.                                       To signal failure, throw an exception or return a rejected promise.                                       This has a default Timeout of 300 MSec from manifest v5 onwards.                              Parameters :                                          hide(event) {}, till Manifest Version V4                                          hide(rootNode, data) {}, from v5 onwards`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`entrypoints.panels.destroy`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This is called when a panel is going to be destroyed. 'this' can be                                          used to access UxpPanelInfo object. To signal failure, throw an exception.                              Parameters :                                          destroy(event) {}, till Manifest Version V4                                          destroy(rootNode) {}, from v5 onwards`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`entrypoints.panels.invokeMenu`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This is called when a panel menu item is invoked.                                             Menu id is passed as the first argument to this function. 'this' can be                                             used to access UxpPanelInfo object. This function can return a promise.                                             To signal failure, throw an exception or return a rejected promise.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`entrypoints.panels.customEntrypoint`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Apart from the above default uxp panel entrypoints, Host Apps can define                                                   additional entrypoints to support custon lifecycle events. Details of the entrypoint like                                                   name, parameters passed, return type, etc. are defined by the host app.                                                   Currently, Photoshop hasn't defined any custom entrypoints.                                                   Xd has defined one custom entrypoint `}<inlineCode parentName="td">{`update`}</inlineCode>{`.                                                        update entrypoint in XD is called whenever panel UI content should be updated.                                                        Parameters : update(scenegraph.selection, scenegraph.update)                                                        `}<a parentName="td" {...{
              "href": "https://developer.adobe.com/xd/uxp/develop/reference/ui/panels/update/"
            }}>{`https://developer.adobe.com/xd/uxp/develop/reference/ui/panels/update/`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`entrypoints.panels.menuItems`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`array of menu items. Each menu item can be a string or an object with                                         properties defined below. Menu items are displayed in the                                         same order as specified in this array. For specifying a separator,                                         a value of "-" or menu item with label "-" can be used at required place in the array.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`entrypoints.panels.menuItems.id`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`identifier of the menu item.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`entrypoints.panels.menuItems.label`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`display text for the menu item. Should be localized. If label is not                                              specified, id is used as label.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`entrypoints.panels.menuItems.enabled`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`enabled/disabled state for the menu item. Default - true.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`entrypoints.panels.menuItems.checked`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`checked state for the menu item. Default - false.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`entrypoints.panels.menuItems.submenu`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`submenu for this menu item again as an array of 'menuItems'.                                               'id' of submenus should still be unique across panel.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`entrypoints.commands`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array<object>`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This object contains a list of key-value pairs where each key is the command id and                                 value is command's data whose type can be an object or function.                                 If a function, it is assumed to be 'run' method (described below).                                 If an objet, it can contain following properties but 'run' is must to specify.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`entrypoints.commands.run`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This is called when the command is invoked via menu entry. 'this' can be used                                      to access UxpCommandInfo object. This function can return a promise.                                      To signal failure, throw an exception or return a rejected promise.                              Parameters :                                          run(event) {}, till Manifest Version V4                                          run(executionContext, ...arguments) {}, from v5 onwards`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`entrypoints.commands.cancel`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`For future use.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const { entrypoints } = require("uxp");
 entrypoints.setup({
     plugin: {
         create() {..},
         destroy() {..}
     },
     panels: {
         "panel1": {
             create() {..},
             show() {..},
             hide() {..},
             destroy() {..},
             invokeMenu() {..},
             update() {..}, // customEntrypoint example
             validatNode() {..} // customEntrypoint example
              menuItems: [
                  {
                      id: "signIn",
                      label: "Sign In...",
                      enabled: false,
                      checked: false
                      submenu: [
                          { id: "submenu1", label: "submenu1", enabled: false, checked: false},
                          { "submenu2" }
                      ]
                  },
                  "-",  // separator.
                  "Sign out",  // by default enabled, and the id will be same with the label.
              ]
          },
          "panel2": {..}
      },
      commands: {
          "command1": {
              run() {..},
              cancel() {..}
          },
          "command2": function(){..}
      }
  });
`}</code></pre>
    <a name="entrypoints-getpanel" id="entrypoints-getpanel"></a>
    <h2 {...{
      "id": "getpanelid"
    }}>{`getPanel(id)`}</h2>
    <p>{`Get panel with specified id`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`UxpPanelInfo`}</inlineCode>{` - - panel object for a valid id
null for an invalid id  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`id`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`panel id`}</td>
        </tr>
      </tbody>
    </table>
    <a name="entrypoints-getcommand" id="entrypoints-getcommand"></a>
    <h2 {...{
      "id": "getcommandid"
    }}>{`getCommand(id)`}</h2>
    <p>{`Get command with specified id`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`UxpCommandInfo`}</inlineCode>{` - - command object for a valid id
null for an invalid id  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`id`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`command id`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      